export default {
	setToken(token) {
		window.localStorage.setItem('jwt_token', token);
	},
	getToken() {
		return window.localStorage.getItem('jwt_token');
    },
    getUser() {
		return window.localStorage.getItem('jwt_user');
	},
	removeToken() {
		window.localStorage.removeItem('jwt_token');
    },
    removeUser(){
        window.localStorage.removeItem('jwt_user');
    },
    removeLicencia() {
		window.localStorage.removeItem('jwt_licencia');
    },

}